// 反向代理
import axios from 'axios';

const href = window.location.href;
// const env=href.indexOf('test')>-1?'test':'prod';
const env = 'test';
const urlMap = {
  test: '//glswdl-ps.test.geely.com',
  prod: '//gidasw.geely.com'
};

let baseURL = urlMap[env];
// if (process.env.VUE_APP_MODE === 'dev') {
//
//   baseURL = process.env.VUE_APP_API_URL;
//
// } else if (process.env.VUE_APP_MODE === 'prod') {
//
//   baseURL = process.env.VUE_APP_API_URL;
//
// }
// 创建 axios 实例
const service = axios.create({
  baseURL: '',
//设置请求地址
  timeout: 60000
// 请求超时时间
//   headers: {
//     'Content-Type': 'application/json'
//   },
//   withCredentials: true // 跨域请求使用凭证
});
export {
  service as axios
};



// WEBPACK FOOTER //
// ./src/utils/request.js